import React, { useContext } from 'react';
import classNames from 'classnames';
import { merge } from 'lodash';

import { Plus, Trash2 } from 'lucide-react';
import Select from '../../components/Select';
import Textarea from '../../components/Textarea';
import NumberInput from '../../components/NumberInput';
import { SELECT_STYLES_MODAL } from '../../utils/const';
import Button from '../../components/Button';
import ConfirmationModal from '../../components/ConfirmationModal';
import { selectValue } from '../../utils/helpers';
import GlobalContext from '../../utils/GlobalContext';

export default function CardTable({
  editMode = false,
  className,
  titles,
  collection,
  collectionEditSettings,
  title,
  maxCount,
  addNewLabel,
  addHandler,
  updateHandler,
  removeHandler,
  titleStyle,
  textStyle,
  backgroundCard,
  titleColor,
  textColor,
  buttonStyle,
  buttonVariant = 'outline',
}) {
  const { locales } = useContext(GlobalContext);
  const optionStyles = {
    option: (styles) => {
      return {
        ...styles,
        fontFamily: 'inherit',
      };
    },
  };

  const buildField = (data, { name, type, options }) => {
    switch (type) {
      case 'text':
        return (
          <Textarea
            value={data[name]}
            delay={700}
            className={`bmc-form-textarea ${textStyle} custom-font-body `}
            onChange={(e) =>
              updateHandler({ id: data.id, name, value: e.target.value })
            }
          />
        );
      case 'number':
        return (
          <NumberInput
            value={data[name]}
            className={`bmc-form-textarea ${textStyle} custom-font-body`}
            onChange={(e) =>
              updateHandler({ id: data.id, name, value: e.target.value })
            }
          />
        );
      case 'select':
        return (
          <div className="custom-font-body">
            <Select
              className={`bmc-form-select ${textStyle} custom-font-body min-w-40`}
              styles={merge(SELECT_STYLES_MODAL, optionStyles)}
              options={options}
              value={selectValue(data[name])}
              onChange={({ value }) =>
                updateHandler({ id: data.id, name, value })
              }
            />
          </div>
        );
      default:
        return null;
    }
  };

  return (
    <div
      className={classNames('bmc-page-fincard-content relative', className)}
      style={{ background: backgroundCard }}
    >
      <div
        className={`bmc-page-fincard-title ${titleStyle} custom-font-title`}
        style={{ color: titleColor }}
      >
        {title}
      </div>

      <table
        className={classNames(
          'bmc-page-fincard-table custom-font-body',
          textStyle,
          {
            'bmc-page-fincard-table--show': !editMode,
          },
        )}
      >
        <thead>
          <tr>
            {titles.map((item, index) => (
              <th key={index} style={{ color: textColor }}>
                {item}
              </th>
            ))}
          </tr>
        </thead>

        <tbody>
          {collection.map((item) => (
            <tr key={item.id}>
              {collectionEditSettings.map((settings, i) => (
                <td key={i}>
                  <div className="bmc-page-fincard-table-title">
                    {titles[i]}
                  </div>

                  <div className="flex flex-row items-center">
                    {editMode
                      ? buildField(item, settings)
                      : item[settings.name]}
                    {editMode &&
                      i === collectionEditSettings.length - 1 &&
                      collection.length > 1 && (
                        <ConfirmationModal
                          className="ml-3 hover:bg-muted-lighter/60 text-muted-darker"
                          body={locales.common.deleteConfirmation}
                          confirmText="Delete"
                          onConfirm={() => removeHandler({ id: item.id })}
                          buttonAriaLabel="Delete"
                        >
                          <Trash2 className="w-6 min-w-6 h-auto" />
                        </ConfirmationModal>
                      )}
                  </div>
                </td>
              ))}
            </tr>
          ))}
        </tbody>
      </table>

      {editMode && collection.length < maxCount && (
        <Button
          variant={buttonVariant}
          onClick={addHandler}
          /*   className={classNames(
            'button-costs-width margin-top-5 margin-left-10 custom-font-body',
            buttonStyle ? `${buttonStyle}` : 'bmc-button--blue',
          )} */
          className={`w-full bg-transparent ${buttonStyle}`}
          /*     style={{ color: buttonColor, background: backgroundButton }} */
        >
          <Plus className="w-7 h-auto" />
          {addNewLabel}
        </Button>
      )}
    </div>
  );
}
